export interface SasUploadInfo {
  sasToken?: string;
  blobName?: string;
  blobUrl?: string;
  uploadUrl?: string;
  expiresOn?: string;
}

function parseSasResponse(sasResponse: any): { uploadUrl: string; blobUrl: string } {
  let data = sasResponse;
  if (typeof data === 'string') {
    const trimmed = data.trim().replace(/^\uFEFF/, '');
    data = trimmed.startsWith('{') ? JSON.parse(trimmed) : { uploadUrl: trimmed };
  }
  if (data && data.Result && typeof data.Result === 'object') {
    data = data.Result;
  }
  const sasToken = (data && data.sasToken ? String(data.sasToken) : '').replace(/^\?/, '');
  const blobUrl = data && data.blobUrl ? String(data.blobUrl).split('?')[0] : '';
  let uploadUrl = '';
  if (blobUrl && sasToken) {
    uploadUrl = blobUrl + '?' + sasToken;
  } else if (data && data.uploadUrl) {
    uploadUrl = String(data.uploadUrl);
  }
  if (!uploadUrl || uploadUrl.indexOf('sig=') === -1) {
    throw new Error('Azure SAS upload URL is missing or invalid');
  }
  return {
    uploadUrl,
    blobUrl: blobUrl || uploadUrl.split('?')[0]
  };
}

function azureErrorMessage(status: number, body: string): string {
  const code = (body.match(/<Code>([^<]+)<\/Code>/) || [])[1];
  const message = (body.match(/<Message>([^<]+)<\/Message>/) || [])[1];
  const detail = (body.match(/<AuthenticationErrorDetail>([^<]+)<\/AuthenticationErrorDetail>/) || [])[1];
  const parts = ['Blob upload failed (' + status + ')'];
  if (code) {
    parts.push(code);
  }
  const text = (detail || message || '').replace(/\s+/g, ' ').trim();
  if (text) {
    parts.push(text);
  }
  return parts.join(' — ');
}

/** PUT the file to uploadUrl from api/get-sas-token. Returns blobUrl to store on the card. */
export async function uploadFile(file: any, sasResponse: any): Promise<string> {
  const { uploadUrl, blobUrl } = parseSasResponse(sasResponse);
  const body = file && file.arrayBuffer ? await file.arrayBuffer() : file;
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      'x-ms-blob-type': 'BlockBlob'
    },
    body
  });
  if (!response.ok) {
    const errorBody = await response.text().catch(() => '');
    throw new Error(azureErrorMessage(response.status, errorBody));
  }
  return blobUrl;
}
